// extracted by css-extract-rspack-plugin
export default {"automatedReviewDiff":"AutomatedReviewDiffEntry-module__automatedReviewDiff__qZi0H"};